// extracted by mini-css-extract-plugin
export default {"form":"ManageUserDialog_form__QrZhb","invoiceToggle":"ManageUserDialog_invoiceToggle__Q5+Jz","invoiceToggleLabel":"ManageUserDialog_invoiceToggleLabel__QeD2K"};